import React, { useEffect, useState } from "react";
import {
  Layout,
  Button,
  Table,
  Space,
  Modal,
  Input,
  Form,
  Switch,
  Popconfirm,
  message,
  Card,
  Typography,
} from "antd";

import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  createMarquee,
  deleteMarquee,
  getMarquee,
  updateMarquee,
  updateMarqueePublishStatus,
} from "../services/marqueeService";

const { Content } = Layout;
const { Title } = Typography;

function Marquee() {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [form] = Form.useForm();

  // Fetch
  const fetchData = async () => {
    try {
      const res = await getMarquee();
      setData(res.data.data);
    } catch (err) {
      message.error("Failed to fetch data");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAddClick = () => {
    setEditingItem(null);
    form.resetFields();
    setOpen(true);
  };

  // Submit
  const handleSubmit = async (values) => {
    try {
      if (editingItem) {
        await updateMarquee(editingItem.id, {
          title: values.title,
        });

        message.success("Updated successfully");
      } else {
        await createMarquee({
          title: values.title,
          isPublic: values.isPublish,
        });

        message.success("Added successfully");
      }

      setOpen(false);
      fetchData();
    } catch (err) {
      message.error("Something went wrong");
    }
  };

  // Delete

  const handleDelete = async (id) => {
    try {
      await deleteMarquee(id);
      message.success("Deleted successfully");
      fetchData();
    } catch (err) {
      message.error("Delete failed");
    }
  };

  // Publish

  const togglePublish = async (checked, record) => {
    try {
      await updateMarqueePublishStatus(record.id, {
        isPublish: checked,
      });

      message.success(
        checked ? "Published Successfully" : "Unpublished Successfully",
      );

      fetchData();
    } catch (err) {
      message.error("Status update failed");
    }
  };

  // Edit

  const handleEdit = (record) => {
    setEditingItem(record);
    setOpen(true);

    form.setFieldsValue({
      title: record.title,
    });
  };

  // Table

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Publish",
      render: (_, record) => (
        <Switch
          checked={record.isPublish}
          onChange={(checked) => togglePublish(checked, record)}
        />
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space direction="vertical">
          <Button icon={<EditOutlined />} onClick={() => handleEdit(record)}>
            Edit
          </Button>

          <Popconfirm
            title="Delete this item?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Layout>
      <Content style={{ padding: 20 }}>
        <Card title={<Title level={4}>Marquee Management</Title>}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddClick}
          >
            Add Marquee
          </Button>
          <br></br>
          <br></br>
          <Table
            columns={columns}
            dataSource={data}
            rowKey="id"
            pagination={false}
          />
        </Card>
      </Content>

      {/* Model */}

      <Modal
        title={editingItem ? "Edit Marquee" : "Add Marquee"}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: "Title required" }]}
          >
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            {editingItem ? "Update" : "Add"}
          </Button>
        </Form>
      </Modal>
    </Layout>
  );
}

export default Marquee;
